export const addIds = (data) => {
  for (let i = 0; i < data.length; i++) {
    data[i].id = i;
  }
  return data;
};

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const validatePhoneNum = (num) => {
  return String(num).match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/);
};

export const createSubmitForm = (form, devices) => {
  return {
    recipient_first_name: form.fname,
    recipient_last_name: form.lname,
    recipient_phone: form.phone,
    recipient_email: form.email,
    recipient_company: form.company,
    address1: form.address1,
    address2: form.address2,
    city: form.city,
    state: form.state,
    postal_code: form.pcode,
    country_code: form.ccode,
    billing_info: {
      name: form.company,
      street1: form.address1,
      city: form.city,
      state: form.state,
      country: form.ccode,
      postal_code: form.pcode,
    },
    order_requested_shipping_service: form.shipping,
    require_signature: form.signature,
    devices: devices.map((device) => ({
      item_sku: device.sku,
      quantity: +device.quantity,
    })),
    patient_identifier: form.patient_identifier ? form.patient_identifier : '',
    practice_identifier: form.practice_identifier ? form.practice_identifier : '',
  };
};


export const skuToNameMap = {
  'PY-200-LTE': 'Pylo Weight Scale',
  '200-LTE': 'Pylo Weight Scale',
  'PY-300-LTE': 'Pylo Weight Scale Plus',
  '300-LTE': 'Pylo Weight Scale Plus',
  'PY-802-LTE': 'Pylo BPM',
  '802-LTE': 'Pylo BPM',
  '800-LTE': 'Pylo BPM',
  'PY-802-XL': 'Pylo BPM XL',
  'PY-900-LTE': 'Pylo BPM 900',
  '900-LTE': 'Pylo BPM 900',
  'CUFF-XL-1': 'XL Cuff',
  'PY-GLU-LTE': 'Pylo BGM',
  'GLU-LTE': 'Pylo BGM',
  'GL1-LTE': 'Pylo BGM',
  'PY-GLU-50': 'Lancets and Strips Bundle',
  'ipulseox': 'iPulse Ox'
};

export const billingStatusToNameMap = {
  'active': 'Active',
  'preactive': 'Preactive',
  'pending_activation': 'Pending Activation',
  'pending_deactivation': 'Pending Deactivation',
  'deactivated': 'Deactivated',
};

export const orderStatusToNameMap = {
  'awaiting_shipment': 'Awaiting Shipment',
  'cancelled': 'Cancelled',
  'shipped': 'Shipped',
};